import React, { useEffect, useRef } from 'react';
import { useAuth } from '../../contexts/AuthContext';
import { API_ORIGIN } from '../../services/api';
import { io } from 'socket.io-client';

// Lightweight global presence pinger: keeps the user marked Online after login
const GlobalPresence = () => {
  const { token } = useAuth();
  const socketRef = useRef(null);

  useEffect(() => {
    if (!token) {
      // On logout or no auth, ensure any existing socket is torn down
      if (socketRef.current) {
        try {
          if (socketRef.current.__hb) clearInterval(socketRef.current.__hb);
        } catch (_) {}
        try { socketRef.current.disconnect(); } catch (_) {}
        socketRef.current = null;
      }
      return;
    }

    // Avoid duplicate connections
    if (socketRef.current) return;

    const url = `${API_ORIGIN}/chat`;
    const s = io(url, {
      path: '/socket.io',
      auth: { token },
      query: { token },
      autoConnect: true,
      transports: ['websocket', 'polling'],
    });
    socketRef.current = s;

    s.on('connect', () => {
      // Request notification permission if not already granted
      if ("Notification" in window && Notification.permission === "default") {
        Notification.requestPermission();
      }

      if (s.__hb) clearInterval(s.__hb);

      // Immediate presence ping on connect
      try { s.emit('presence_ping'); } catch (_) {}
      // Heartbeat every 15s to keep Online status updated
      const hb = setInterval(() => {
        try { s.emit('presence_ping'); } catch (_) {}
      }, 15000);
      s.__hb = hb;
    });

    s.on('new_announcement', (annc) => {
      console.log("Received new announcement notification:", annc);
      if ("Notification" in window && Notification.permission === "granted") {
        const textContent = annc.content ? annc.content.replace(/<[^>]+>/g, '').substring(0, 50) + "..." : "";
        new Notification(`New Announcement: ${annc.title}`, {
          body: textContent,
          icon: '/favicon.ico' // optional, you can replace with a logo path
        });
      }
    });

    s.on('connect_error', () => { /* silent: presence-only */ });
    s.on('error', () => { /* silent: presence-only */ });

    return () => {
      // Cleanup on unmount
      if (socketRef.current) {
        try { if (socketRef.current.__hb) clearInterval(socketRef.current.__hb); } catch (_) {}
        try { socketRef.current.disconnect(); } catch (_) {}
        socketRef.current = null;
      }
    };
  }, [token]);

  return null; // no UI
};

export default GlobalPresence;
